import clsx from "clsx";
import type { GuestCreatePayload } from "@/types/camping";

const inputClass = "eh-input";

export interface PlaceBanFieldsProps {
  guest: GuestCreatePayload;
  onChange: (guest: GuestCreatePayload) => void;
  disabled?: boolean;
}

export function PlaceBanFields({ guest, onChange, disabled }: PlaceBanFieldsProps) {
  const banned = guest.is_place_banned ?? false;

  return (
    <fieldset
      className={clsx(
        "space-y-3 rounded-xl border p-4",
        banned ? "border-status-red/40 bg-status-red/5" : "border-separator",
      )}
      disabled={disabled}
    >
      <label className="flex cursor-pointer items-start gap-3 text-sm">
        <input
          type="checkbox"
          className="mt-0.5 shrink-0"
          checked={banned}
          onChange={(e) =>
            onChange({
              ...guest,
              is_place_banned: e.target.checked,
              place_ban_reason: e.target.checked ? guest.place_ban_reason ?? "" : "",
            })
          }
          disabled={disabled}
        />
        <span>
          <span className="font-medium text-label-primary">Platzverbot</span>
          <span className="mt-0.5 block text-label-secondary">
            Buchungen dieser Person werden intern als Anfrage markiert. Der Gast erhält keine
            Hinweise.
          </span>
        </span>
      </label>
      {banned ? (
        <label className="block text-sm">
          <span className="mb-1 block text-label-secondary">Begründung *</span>
          <textarea
            className={clsx(inputClass, "min-h-[4rem] resize-y")}
            value={guest.place_ban_reason ?? ""}
            onChange={(e) => onChange({ ...guest, place_ban_reason: e.target.value })}
            required
            rows={2}
            disabled={disabled}
            placeholder="z. B. wiederholte Regelverstöße, Zahlungsausfall …"
          />
        </label>
      ) : null}
    </fieldset>
  );
}
